<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";

// Custom Components
import PbxServerForm from "@/components/superAdmin/pbxServerForm.vue";
import PageHeader from "@/components/page-header";
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";
import middlewares from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    PbxServerForm,
  },
  data() {
    return {
      title: "PBX Server",
      pbxserverlist: [],
      pbxServerId: null,
      isShowPbxServerForm: false,
      isLoading: false,
      isEdit: false,
      isMounted: true,
      hotels: [],
      isFilterLoading: false,
      filter: {
        server_name: "",
        server_ip: "",
        security_group_name: "",
        security_group_id: "",
      },
      group_names: [],
      group_ids: [],
      isFilterApply: false,
      baseQuery: "",
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getPBXServerList();
  },
  methods: {
    // Method is use for get app feature list
    async getPBXServerList(query) {
      this.isLoading = true;
      try {
        const response = await PbxService.getPBXServerList(query ? query : "");
        if (this.isMounted) {
          response.result.forEach((element) => {
            if (!this.group_names.includes(element.security_group_name)) {
              this.group_names.push(element.security_group_name);
            }
            if (!this.group_ids.includes(element.security_group_id)) {
              this.group_ids.push(element.security_group_id);
            }
          });
        }
        this.pbxserverlist = response.result;
        this.isLoading = false;
        this.isFilterLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isFilterLoading = false;
        errorHandler(error);
      }
    },
    editPbxServe(pbx_server_id) {
      this.pbxServerId = pbx_server_id;
      this.editPbxServerForm();
      this.isEdit = true;
    },
    editPbxServerForm() {
      this.isShowPbxServerForm = !this.isShowPbxServerForm;
    },
    handleSubmit(data) {
      if (this.isEdit) {
        this.pbxserverlist = this.pbxserverlist.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.getPBXServerList();
      }
      this.editPbxServerForm();
      this.isEdit = false;
    },
    handleCancel() {
      this.isEdit = false;
      this.editPbxServerForm();
    },
    deletePbxServer(pbx_server_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            await PbxService.deletePBXServerDetail(pbx_server_id);
            this.pbxserverlist.splice(index, 1);
            middlewares.notification("Deleted successfully !!", "danger");
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },
    async filterApply(proccess) {
      this.isMounted = false;
      if (proccess == "clear") {
        if (this.baseQuery != "") {
          this.isFilterLoading = true;
          await this.getPBXServerList("");
          this.baseQuery = "";
        }
        this.isFilterApply = false;
        this.filter.server_name = "";
        this.filter.server_ip = "";
        this.filter.security_group_name = "";
        this.filter.security_group_id = "";
      } else {
        let isFirstFilterAssing = false;
        this.isFilterApply = true;
        this.baseQuery = "";
        if (this.filter.server_name !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?server_name=${this.filter.server_name}`)
            : (this.baseQuery += `&server_name=${this.filter.server_name}`);
          isFirstFilterAssing = true;
        }
        if (this.filter.server_ip !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?server_ip=${this.filter.server_ip}`)
            : (this.baseQuery += `&server_ip=${this.filter.server_ip}`);
          isFirstFilterAssing = true;
        }
        if (this.filter.security_group_id !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?security_group_id=${this.filter.security_group_id}`)
            : (this.baseQuery += `&security_group_id=${this.filter.security_group_id}`);
          isFirstFilterAssing = true;
        }
        if (this.filter.security_group_name !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?security_group_name=${this.filter.security_group_name}`)
            : (this.baseQuery += `&security_group_name=${this.filter.security_group_name}`);
          isFirstFilterAssing = true;
        }
        if (isFirstFilterAssing && this.baseQuery !== "") {
          this.isFilterLoading = true;
          await this.getPBXServerList(this.baseQuery);
        }
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="editPbxServerForm"
      text="Add New PBX Server"
      :isButton="true"
    />
    <b-card>
      <div class="row">
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="Search by server name"
            v-model="filter.server_name"
          />
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="Search by Server ip"
            v-model="filter.server_ip"
          />
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <select
            name="is_active"
            id="is_active"
            class="form-control mb-2"
            v-model="filter.security_group_name"
            placeholder="search by group name"
          >
            <option value="">Security Group Name</option>
            <option
              v-for="(group, index) in group_names"
              :key="index"
              :value="group"
            >
              {{ group }}
            </option>
          </select>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <select
            name="is_active"
            id="is_active"
            class="form-control mb-2"
            v-model="filter.security_group_id"
            placeholder="search by group id"
          >
            <option value="">Security Group ID</option>
            <option v-for="(id, index) in group_ids" :key="index" :value="id">
              {{ id }}
            </option>
          </select>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-2">
          <button
            class="btn btn-primary float-end float-lg-start mb-2 me-2"
            @click="filterApply('apply')"
            :disabled="isFilterLoading"
          >
            Apply Filter
          </button>
          <button
            class="btn btn-primary float-end float-lg-start mb-2"
            @click="filterApply('clear')"
            :disabled="isFilterLoading"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light" slot="head">
            <tr>
              <th>Server Name</th>
              <th>IP</th>
              <th>Security Group Name</th>
              <th>Security Group Id</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 5" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(pbx, index) in pbxserverlist" :key="index">
              <td @click="editPbxServe(pbx.id)">
                {{ pbx.server_name }}
              </td>
              <td @click="editPbxServe(pbx.id)">
                {{ pbx.server_ip }}
              </td>
              <td @click="editPbxServe(pbx.id)">
                {{ pbx.security_group_name }}
              </td>
              <td @click="editPbxServe(pbx.id)">
                {{ pbx.security_group_id }}
              </td>
              <td>
                <i
                  class="fas fa-pencil-alt text-success"
                  v-b-popover.hover="'Edit'"
                  @click="editPbxServe(pbx.id)"
                ></i>
                <i
                  class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                  v-b-popover.hover="'Delete'"
                  @click="deletePbxServer(pbx.id, index)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
    <!-- Drawer is used to open pbx server form -->
    <Drawer
      @close="handleCancel"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="isShowPbxServerForm">
        <PbxServerForm
          :pbxServerId="this.pbxServerId"
          :isEdit="this.isEdit"
          @cancelSubmit="handleCancel"
          @submitted="handleSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>
